<template>
  <div class="AboutPage">
    <div v-if="isLoading">
      <PreLoad />
    </div>
    <div v-else class="container mb-5">
      <div class="row" dir="rtl">
        <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3">
          <img src="../../assets/about.jpg" class="w" alt="فروشگاه نورا">
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-12 mb-3 flx" dir="rtl">
          <PageContent mode="AboutPage" />

          <!-- <h1>درباره نورا</h1>
          <p>نورا با تیم قوی در حوزه فروش و بازاریابی برای ساختن یک زیر ساخت جدید و ارائه بهترین خدمات اینترنتی طراحی شده است.</p>
          <h2>پشتیبانی نورا</h2>
          <p>در صورت بروز هرگونه مشکل می‌توانید از راه‌های ارتباطی در صفحه (<a href="/contact" class="text-info">ارتباط‌با‌ما</a>) در تماس باشید.</p>
          <h2>روش‌های ارسال محصولات</h2>
          <p>ارسال محصولات برای ساکنین شهر تهران با هماهنگی قبلی توسط پیک و سرویس ارسال نورا انجام می‌شود و بسته‌های شهر‌های غیر از تهران توسط تیپاکس به دست مشتریان خواهد رسید</p> -->

          <div class="d-flex">
            <div class="mx-3">
                <div id="zarinpal">
                </div>
            </div>
            <div class="mx-3">
                <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=246706&amp;Code=O2DJ52b1u6dTqh3LpIE8"><img referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=246706&amp;Code=O2DJ52b1u6dTqh3LpIE8" alt="" style="cursor:pointer" id="O2DJ52b1u6dTqh3LpIE8"></a>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <h2 class="mb-2 team" dir="rtl">اعضای تیم نورا</h2>
      <div class="overflow-auto mb-6">
          <div class="d-flex">
            <div class="card" style="width: 18rem;">
              <img src="../../assets/mohammad.jpg" alt="mohammad ayatollahi">
              <div class="card-body">
                <h6>سید محمدمهدی آیت اللهی</h6>
                <p dir="ltr" class="card-text">Manager</p>
              </div>
            </div>
            <div class="card mb-4" style="width: 18rem;">
              <img src="../../assets/taha.jpg" alt="taha ayatollahi">
              <div class="card-body">
                <h6>سید طه آیت اللهی</h6>
                <p dir="ltr" class="card-text">Programmer & Web Developer</p>
              </div>
            </div>
            <div class="card" style="width: 18rem;">
              <img src="../../assets/sia.jpg" alt="امیرحسین نبی‌پور">
              <div class="card-body">
                <h6>امیرحسین نبی‌پور</h6>
                <p dir="ltr" class="card-text">Programmer & Web Developer</p>
              </div>
            </div>
            <div class="card" style="width: 18rem;">
              <img src="../../assets/najafi.jpg" alt="hasti najafi">
              <div class="card-body">
                <h6>هستی نجفی</h6>
                <p dir="ltr" class="card-text">Salesperson</p>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageContent from '@/components/PageContent.vue'
import PreLoad from '@/components/PreLoad.vue'

export default {
  name: 'AboutPage',
  components: {
    PageContent,
    PreLoad
  },
  data () {
    return {
      isLoading: true
    }
  },
  methods: {
    preloadImages () {
      const images = [
        require('@/assets/about.jpg'),
        require('@/assets/mohammad.jpg'),
        require('@/assets/taha.jpg'),
        require('@/assets/sia.jpg'),
        require('@/assets/najafi.jpg')
      ]

      const promises = images.map(src => {
        return new Promise((resolve, reject) => {
          const img = new Image()
          img.src = src
          img.onload = resolve
          img.onerror = reject
        })
      })

      return Promise.all(promises)
    }
  },
  async mounted () {
    try {
      await this.preloadImages()
      const query = `
      {
        meta(key:"${this.$options.name}") {
          seoTitle
          seoKeyword
          seoDescription
        }
      }
      `
      const res = await this.$fetchGraphQL(query)
      this.setMetaByObj(res.data.meta)
      document.getElementById('zarinpal').innerHTML = '<a href="https://www.zarinpal.com/trustPage/nuorashop.ir" title="دروازه پرداخت معتبر"><img src="https://cdn.zarinpal.com/badges/trustLogo/1.svg" border="0" alt="دروازه پرداخت معتبر"></a>'
    } catch (error) {
      console.error('Error loading page:', error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.w{
  width: -webkit-fill-available;
  width: -moz-available;
  margin: 2rem;
}
.flx{
  display: flex;
  flex-direction: column;
  justify-content: center;
}
p {
  color:rgba(0,0,0,.55);
  margin-bottom: 3rem;
}
h1 {
  font-size:17pt;
}
h2 {
  font-size:15pt;
}
h3 {
  font-size:13pt;
}
.card{
  border-radius: 24px;
  min-width: 250px;
  margin: 10px;
}
.mb-6{
  margin-bottom: 5rem;
}
h2.team{
  font-size: 24pt !important;
  margin-bottom: 1rem !important;
}
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
img{
  aspect-ratio: 1/1;
}
</style>
